var map = {
	"./left1.png": "./src/assets/img/cockpit/warn/left1.png",
	"./left2.png": "./src/assets/img/cockpit/warn/left2.png",
	"./left3.png": "./src/assets/img/cockpit/warn/left3.png",
	"./left4.png": "./src/assets/img/cockpit/warn/left4.png",
	"./left5.png": "./src/assets/img/cockpit/warn/left5.png",
	"./left_left.png": "./src/assets/img/cockpit/warn/left_left.png",
	"./left_right.png": "./src/assets/img/cockpit/warn/left_right.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/cockpit/warn sync recursive ^\\.\\/left.*\\.png$";